import CompanyManagementPage from '@/pages/CompanyManagementPage';
// Keeping the old HomePage file intact; route now points to the new minimal dashboard
import DashboardCreateSessionPage from '@/pages/DashboardCreateSessionPage';
import { CreateSessionLandingPage } from '@/pages/CreateSessionLandingPage';
import DistributionGroupDetailPage from '@/pages/DistributionGroupDetailPage';
import LoggedOutPage from '@/pages/LoggedOutPage';
import NewTranscriptPage from '@/pages/NewTranscriptionPages/NewTranscriptPageV4';
import SelfIntakePage from '@/pages/NewTranscriptionPages/SelfIntakePage';
import PeoplePage from '@/pages/PeoplePage';
import PersonDetailPage from '@/pages/PersonDetailPage';
import RecordsPage from '@/pages/RecordsPage';
import { CollectionsPage } from '@/pages/CollectionsPage';
import TemplateEditPage from '@/pages/TemplateEditPage/TemplateEditPageV2';
import TemplatesPage from '@/pages/TemplatesPage';
import TasksPage from '@/pages/TasksPage';
import { AiChatPage } from '@/pages/AiChatPage';
import AdminSmsPage from '@/pages/AdminSmsPage';
import AssemblyAITranscribePage from '@/pages/AssemblyAITranscribePage';
import { Route, Routes, Navigate } from 'react-router-dom';
import AcceptInvitationPage from '@/pages/AcceptInvitationPage';
import CustomerDocumentMagicLinkPage from '@/pages/CustomerDocumentMagicLinkPage';
import MagicLinkShortUrlPage from '@/pages/MagicLinkShortUrlPage';
import { ProtectedRoute } from '@/components/ProtectedRoute/ProtectedRoute';
import { CollectionDetailPage } from '@/pages/CollectionDetailPage';
import HelpPage from '@/pages/HelpPage';
import NotFoundPage from '@/pages/NotFoundPage';
import { PageTransition } from '@/components/PageTransition';

const AuthenticatedApp = () => {
  return (
    <PageTransition>
      <Routes>
      <Route path="/" element={<LoggedOutPage />} />

      {/* <Route path="/loggedout" element={<LoggedOutPage />} /> */}

      <Route path="/organization" element={<CompanyManagementPage />} />

      {/* Create session routes */}
      <Route path="/create/record" element={<DashboardCreateSessionPage mode="record" />} />
      <Route path="/create/upload" element={<DashboardCreateSessionPage mode="upload" />} />
      {/* Redirect /create to /create/record by default, keep landing page for backward compatibility */}
      <Route path="/create" element={<Navigate to="/create/record" replace />} />
      
      {/* Legacy dashboard route - redirect to record page */}
      <Route path="/dashboard" element={<Navigate to="/create/record" replace />} />

      <Route
        path="/tasks"
        element={<ProtectedRoute element={<TasksPage />} requireSuperAdmin />}
      />

      <Route path="/templates" element={<Navigate to="/organization?tab=templates" replace />} />

      <Route
        path="/templates/:id/:templateName/edit"
        element={<TemplateEditPage />}
      />

      {/* New session-based transcription route - now uses unified file detail page */}
      <Route path="/transcript/:sessionId" element={<NewTranscriptPage />} />

      {/* Self-intake route scoped to a session */}
      <Route
        path="/transcript/:sessionId/self-intake"
        element={<SelfIntakePage />}
      />

      {/* Legacy template-based route for backward compatibility */}
      <Route
        path="/new-intake/:templateId/:templateName"
        element={<NewTranscriptPage />}
      />

      <Route
        path="/people"
        element={<ProtectedRoute element={<PeoplePage />} requireSuperAdmin />}
      />
      <Route
        path="/people/:id"
        element={
          <ProtectedRoute element={<PersonDetailPage />} requireSuperAdmin />
        }
      />

      <Route
        path="/distribution-groups/:groupId"
        element={<DistributionGroupDetailPage />}
      />

      <Route path="/collections" element={<CollectionsPage />} />
      <Route path="/collections/:id" element={<CollectionDetailPage />} />

      <Route path="/records" element={<RecordsPage />} />

      {/* Unified file detail page - works for recordings, PDFs, images, etc. */}
      <Route path="/file/:fileType/:fileId" element={<NewTranscriptPage />} />
      <Route path="/ai-chat" element={<AiChatPage />} />
      <Route
        path="/admin"
        element={<ProtectedRoute element={<AdminSmsPage />} requireSuperAdmin />}
      />

      <Route path="/help" element={<HelpPage />} />

      {/* Public route for accepting invitations */}
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      <Route path="/l/:code" element={<MagicLinkShortUrlPage />} />
      <Route
        path="/share-link/customer-document/:artifactId"
        element={<CustomerDocumentMagicLinkPage />}
      />

      {/* Minimal AssemblyAI streaming test page */}
      <Route
        path="/assemblyai-transcribe"
        element={<AssemblyAITranscribePage />}
      />

      {/* 404 catch-all route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    {/* <OnboardingTour /> */}
    </PageTransition>
  );
};

export default AuthenticatedApp;
